<template>
	<div :class="theme">
		<div class="title">
			<img :src="titleImg" />
			<div v-if="language === 'zh'" class="text">
				<div ref="myDiv" style="z-index: 999;">{{ zhTitle }}</div>
				<div :class="isLongChart ? '':'bg'" :style="{ width: bgWidth + 'px' }"></div>
			</div>
			<div v-else-if="language === 'en'" class="text">
				<div ref="myDiv" style="z-index: 999;">{{ enTitle }}</div>
				<div :class="isLongChart ? '':'bg'" :style="{ width: bgWidth + 'px' }"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Title',
	props: {
		zhTitle: {
			type: String,
		},
		enTitle: {
			type: String,
		},
	},
	data() {
		return {
			bgWidth: 0,
			titleImg: '',
		}
	},
	computed: {
		...mapState(['theme', 'language', 'isLongChart']),
	},
	watch: {
		zhTitle(newData, oldData) {
			this.$nextTick(() => {
				this.bgWidth = this.$refs.myDiv.offsetWidth
			})
		},
		enTitle(newData, oldData) {
			this.$nextTick(() => {
				this.bgWidth = this.$refs.myDiv.offsetWidth
			})
		},
	},
	mounted() {
		this.bgWidth = this.$refs.myDiv.offsetWidth
		if (this.theme !== 'purple') {
			this.titleImg = require('../assets/image/' + this.theme + '/title.png')
		}
	},
	methods: {},
}
</script>

<style lang="scss" scoped>
.red {
	.title {
		display: flex;
		align-items: center;
		height: 74px;
	}

	.title img {
		width: 81px;
		height: 74px;
	}
	.title .text {
		margin-left: 13px;
		height: 30px;
		font-size: 22px;
		font-weight: 600;
		color: var(--baseColor);
		line-height: 30px;
	}
}

.purple {
	.title {
		.bg {
			position: absolute;
			bottom: 20px;
			height: 10px;
			background-color: #f3adbf;
			opacity: 0.8;
		}
	}

	.title img {
		display: none;
	}
	.title .text {
		display: flex;
		align-items: center;
		position: relative;
		margin-left: 51px;
		height: 64px;
		font-weight: 600;
		font-size: 22px;
		color: #2a234c;
		line-height: 30px;
	}
}
.blue {
	.title {
		display: flex;
		align-items: center;
	}

	.title img {
		width: 68px;
		height: 18px;
	}
	.title .text {
		margin-left: 13px;
		height: 30px;
		font-size: 22px;
		font-weight: 600;
		color: #0a0a0a;
		line-height: 30px;
	}
}

.yellow {
	.title {
		display: flex;
		align-items: center;
		padding-top: 25px;
	}

	.title img {
		width: 24px;
		height: 24px;
	}
	.title .text {
		margin-left: 13px;
		height: 30px;
		font-size: 22px;
		font-weight: 600;
		color: #0a0a0a;
		line-height: 30px;
	}
}
</style>
